import { useState } from "react";
import { TableContainer, Typography, Tabs, Box, Tab } from "@mui/material";
import { find, map } from "lodash";
import Relatorio5Mes from "./relatorio5Mes";
import moment from "moment";
import { IRelatorio, RelatorioRendaVariavel } from "../../../models/declaracao";
import { TabContext, TabPanel } from "@mui/lab";
import EmptyState from "../../util/ui/emptyState";
import { felixTokens, radius } from "../../../theme";

type Props = {
  relatorio: IRelatorio<RelatorioRendaVariavel>;
};

export default function Relatorio5({ relatorio }: Props) {
  const meses = moment.monthsShort();
  const [tab, setTab] = useState(meses[0]);

  const handleTabChange = (_: unknown, newValue: string) => {
    setTab(newValue);
  };

  return (
    <Box display="flex" flexDirection="row">
      <TabContext value={tab}>
        <Tabs
          orientation="vertical"
          onChange={handleTabChange}
          value={tab}
          TabIndicatorProps={{ hidden: true }}
          // Trilho de meses: rótulo mono uppercase, mês ativo sobe para
          // `surface` com filete accent-ink à esquerda.
          sx={{
            "& .MuiTab-root": {
              minWidth: 80,
              fontFamily: felixTokens.fontMono,
              fontSize: "0.6875rem",
              fontWeight: 500,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "text.secondary",
              borderRadius: `${radius.xl}px 0px 0px ${radius.xl}px`,
              border: (theme) => `1px solid ${theme.palette.divider}`,
              backgroundColor: "action.hover",
              "&.Mui-selected": {
                color: "text.primary",
                borderLeftWidth: 4,
                borderLeftColor: (theme) => theme.palette.accentInk,
                backgroundColor: "background.paper",
                borderRight: "transparent",
              },
            },
          }}
        >
          {map(meses, (mes) => (
            <Tab key={mes} value={mes} label={mes} />
          ))}
        </Tabs>

        {map(meses, (mes) => {
          const resultadoMes = find(
            relatorio.valores,
            (valor) => valor.dataBase.format("MMM") === mes
          );

          return (
            <TabPanel
              key={mes}
              value={mes}
              sx={{ ml: 4, flex: "1 1 auto", py: 0 }}
            >
              {resultadoMes ? (
                <TableContainer>
                  <Relatorio5Mes resultadoMes={resultadoMes} />
                </TableContainer>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  width="100%"
                  paddingX={4}
                >
                  <EmptyState maxHeight="50%" maxWidth="80%" />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    textAlign="center"
                    sx={{ padding: 2 }}
                  >
                    Não há resultados para esse mês.
                  </Typography>
                </Box>
              )}
            </TabPanel>
          );
        })}
      </TabContext>
    </Box>
  );
}
